function vmWaitForOneTrust() {
	let attempts = 0;
	const interval = setInterval(function () {
		if (vmHasOneTrustLoaded() && attempts <= 2) {
			vmOptanonWrapper();
		}
		if (vmHasOneTrustLoaded() && attempts > 2) {
			clearInterval(interval);
		}
		attempts++;
	}, 100)
}

function vmHasOneTrustLoaded() {
	if (typeof window.OnetrustActiveGroups === 'string') {
		// Set up the wrapper for future consent changes
		window.OptanonWrapper = vmOptanonWrapper;
		return true;
	}
	return false;
}

function vmsendConsent(trackingConsent) {
	console.log(trackingConsent)
	window.Shopify.customerPrivacy.setTrackingConsent(trackingConsent, () => {
		console.log("Shopify Consent Captured")
		//To reload a page once consent is updated by the user
		document.querySelectorAll('.save-preference-btn-handler.onetrust-close-btn-handler, #onetrust-accept-btn-handler, #onetrust-reject-all-handler, #accept-recommended-btn-handler').forEach(el => {
			el.addEventListener('click', function () {
				window.location.reload();
			});
		});
	});
}

function vmConsent(iframe) {
	// Get all elements with the specified class
	var consentElements = document.getElementsByClassName('consent-video-btn');
	// Check if any elements were found
	while (consentElements.length > 0) {
		// Remove the first element with the specified class
		consentElements[0].remove();
	}

	// Get the div elements by their class name
	const consentDivs = document.getElementsByClassName('vm-consent-thumb');
	const autoplayControl = document.getElementById('vimeo-control')
	// Loop through the divs and set their display property to "block"
	for (let i = 0; i < consentDivs.length; i++) {
		consentDivs[i].style.display = 'block';
	}

    let iframes = document.getElementsByTagName("iframe");
    iframes[0].remove();
    var containerElements = document.getElementsByClassName('vid-container');
    containerElements[0].remove();  
}
function hideIframes()
{
	let iframes = document.getElementsByTagName("iframe");
	for (var i = 0; i < iframes.length; i++) {
		let src = iframes[i].getAttribute('data-src');
		if (src && src.includes("vimeo.com")) {
			iframes[i].style.display="none";
			
		}
	}
}

function vmOptanonWrapper() {
	performanceConsent = !!window.OnetrustActiveGroups.includes('C0002');
	functionalConsent = !!window.OnetrustActiveGroups.includes('C0003');
	targetingConsent = !!window.OnetrustActiveGroups.includes('C0004');
	const trackingConsent = { analytics: performanceConsent, marketing: targetingConsent, preferences: functionalConsent, sale_of_data: false };

	window.Shopify.loadFeatures(
		[
			{
				name: 'consent-tracking-api',
				version: '0.1',
			},
		],
		error => {
			if (error) {
				console.error('Shopify consent tracking API error:', error);
				return;
			}
			vmsendConsent(trackingConsent)
		},
	);
	if (!window.OnetrustActiveGroups.includes('C0002') || !window.OnetrustActiveGroups.includes('C0003') || !window.OnetrustActiveGroups.includes('C0004') || !window.OnetrustActiveGroups.includes('C0005')) {
		let iframes = document.getElementsByTagName("iframe");

		hideIframes()
		for (var i = 0; i < iframes.length; i++) {
			let src = iframes[i].getAttribute('data-src');
			if (src && src.includes("vimeo.com")) {
				if (src.includes('autoplay=1')) {
					iframes[i].src = src.replace("autoplay=1&", "")
                  if(document.getElementById('vimeo-control')!==null && document.getElementById('vimeo-control') !== undefined){
					document.getElementById('vimeo-control').style.display = "none";
                  }
					iframes[i].src='';
					
				}
			
				vmConsent(iframes[i]);
			}
		}
	}
}

(function () {
	// Loop through the divs and set their display property to "none"
	// Get the div elements by their class name
	const consentDiv = document.getElementsByClassName('vm-consent-thumb');
	for (let i = 0; i < consentDiv.length; i++) {
		consentDiv[i].style.display = 'none';
	}
	vmWaitForOneTrust();
})();
